export { default as ModuleRenderer } from './ModuleRenderer';
